module.exports = __webpack_public_path__ + "static/slat_gradient_loop-18a4166f60e7513bcfe7d106357c3e9d.mp4";